import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import r from "../../core/Collection.js";
import s from "../../core/CollectionFlattener.js";
import t from "../../core/Error.js";
import o from "../../core/Logger.js";
import { property as a } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { getProperties as l } from "../../core/accessorSupport/utils.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import { nameToId as n, idToName as u } from "../../core/accessorSupport/PropertyOrigin.js";
import y from "../support/Sublayer.js";
import { isSublayerOverhaul as c } from "../support/sublayerUtils.js";
var b = o.getLogger("esri.layers.TileLayer");

function p(e, r) {
  var s = [],
      t = {};
  return e ? (e.forEach(function (e) {
    var o = new y();

    if (o.read(e, r), t[o.id] = o, null != e.parentLayerId && -1 !== e.parentLayerId) {
      var _r = t[e.parentLayerId];
      _r.sublayers || (_r.sublayers = []), _r.sublayers.unshift(o);
    } else s.unshift(o);
  }), s) : s;
}

var d = r.ofType(y);

function h(e, r) {
  e && e.forEach(function (e) {
    r(e), e.sublayers && e.sublayers.length && h(e.sublayers, r);
  });
}

var f = function f(o) {
  var f = /*#__PURE__*/function (_o) {
    _inherits(f, _o);

    var _super = _createSuper(f);

    function f() {
      var _this;

      _classCallCheck(this, f);

      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(e)), _this.allSublayers = new s({
        getCollections: function getCollections() {
          return [_this.sublayers];
        },
        getChildrenFunction: function getChildrenFunction(e) {
          return e.sublayers;
        }
      }), _this.sublayersSourceJSON = {
        2: {},
        3: {},
        4: {},
        5: {}
      }, _this.handles.add(_this.watch("sublayers", function (e, r) {
        return _this._handleSublayersChange(e, r);
      }, !0));
      return _this;
    }

    _createClass(f, [{
      key: "readSublayers",
      value: function readSublayers(e, r) {
        if (!r || !e) return;
        var s = this.sublayersSourceJSON,
            t = n(r.origin);
        if (t < 2) return;
        if (s[t] = {
          context: r,
          visibleLayers: e.visibleLayers || s[t].visibleLayers,
          layers: e.layers || s[t].layers
        }, t > 2) return;

        this._set("serviceSublayers", this.createSublayersForOrigin("service").sublayers);

        var _this$createSublayers = this.createSublayersForOrigin("web-document"),
            o = _this$createSublayers.sublayers,
            a = _this$createSublayers.origin,
            i = l(this);

        i.setDefaultOrigin(a), this._set("sublayers", new d(o)), i.setDefaultOrigin("user");
      }
    }, {
      key: "findSublayerById",
      value: function findSublayerById(e) {
        return this.allSublayers.find(function (r) {
          return r.id === e;
        });
      }
    }, {
      key: "createServiceSublayers",
      value: function createServiceSublayers() {
        return this.createSublayersForOrigin("service").sublayers;
      }
    }, {
      key: "createSublayersForOrigin",
      value: function createSublayersForOrigin(e) {
        var r = n("web-document" === e ? "web-map" : e);
        var s = 2,
            t = this.sublayersSourceJSON[2].layers,
            o = this.sublayersSourceJSON[2].context,
            a = null;
        var l = [3, 4, 5].filter(function (e) {
          return e <= r;
        });

        var _iterator = _createForOfIteratorHelper(l),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _n3 = _step.value;
            var _e = this.sublayersSourceJSON[_n3];
            c(_e.layers) && (s = _n3, t = _e.layers, o = _e.context, _e.visibleLayers && (a = {
              visibleLayers: _e.visibleLayers,
              context: _e.context
            }));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var i = [3, 4, 5].filter(function (e) {
          return e > s && e <= r;
        });
        var y = null;

        var _iterator2 = _createForOfIteratorHelper(i),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _n4 = _step2.value;
            var _this$sublayersSource = this.sublayersSourceJSON[_n4],
                _e2 = _this$sublayersSource.layers,
                _r2 = _this$sublayersSource.visibleLayers,
                _s = _this$sublayersSource.context;
            _e2 && (y = {
              layers: _e2,
              context: _s
            }), _r2 && (a = {
              visibleLayers: _r2,
              context: _s
            });
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        var b = p(t, o),
            _f = new Map(),
            S = new Set();

        if (y) {
          var _iterator3 = _createForOfIteratorHelper(y.layers),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _n = _step3.value;

              _f.set(_n.id, _n);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }

        if (a) {
          var _iterator4 = _createForOfIteratorHelper(a.visibleLayers),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _n2 = _step4.value;
              S.add(_n2);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }

        return h(b, function (e) {
          y && e.read(_f.get(e.id), y.context), a && e.read({
            defaultVisibility: S.has(e.id)
          }, a.context);
        }), {
          origin: u(s),
          sublayers: new d({
            items: b
          })
        };
      }
    }, {
      key: "read",
      value: function read(e, r) {
        _get(_getPrototypeOf(f.prototype), "read", this).call(this, e, r), this.readSublayers(e, r);
      }
    }, {
      key: "_handleSublayersChange",
      value: function _handleSublayersChange(e, r) {
        var _this2 = this;

        r && (r.forEach(function (e) {
          e.parent = null, e.layer = null;
        }), this.handles.remove("sublayers-owner")), e && (e.forEach(function (e) {
          e.parent = _this2, e.layer = _this2;
        }), this.handles.add([e.on("after-add", function (_ref) {
          var e = _ref.item;
          e.parent = _this2, e.layer = _this2;
        }), e.on("after-remove", function (_ref2) {
          var e = _ref2.item;
          e.parent = null, e.layer = null;
        })], "sublayers-owner"), "tile" === this.type && this.handles.add(e.on("before-changes", function (e) {
          b.error(new t("tilelayer:sublayers-non-modifiable", "ISublayer can't be added, moved, or removed from the layer's sublayers", {
            layer: _this2
          })), e.preventDefault();
        }), "sublayers-owner"));
      }
    }]);

    return f;
  }(o);

  return e([a({
    readOnly: !0
  })], f.prototype, "allSublayers", void 0), e([a({
    readOnly: !0,
    type: r.ofType(y)
  })], f.prototype, "serviceSublayers", void 0), e([a({
    value: null,
    type: d,
    json: {
      read: !1,
      write: {
        allowNull: !0,
        ignoreOrigin: !0
      }
    }
  })], f.prototype, "sublayers", void 0), e([a({
    readOnly: !0
  })], f.prototype, "sublayersSourceJSON", void 0), f = e([i("esri.layers.mixins.SublayersOwner")], f), f;
};

export { f as SublayersOwner, h as forEachSublayer };